<template>
  <base-nav
    container-classes="container-fluid"
    class="navbar-top border-bottom navbar-expand"
    :class="{ 'bg-primary navbar-dark': type === 'default' }"
  >
    <ul class="navbar-nav d-xl-none">
      <li class="nav-item">
        <!-- Sidenav toggler -->
        <div
          class="pr-3 sidenav-toggler"
          :class="{
            active: $sidebar.showSidebar,
            'sidenav-toggler-dark': type === 'default',
            'sidenav-toggler-light': type === 'light'
          }"
          @click="toggleSidebar"
        >
          <div class="sidenav-toggler-inner">
            <i class="sidenav-toggler-line"></i>
            <i class="sidenav-toggler-line"></i>
            <i class="sidenav-toggler-line"></i>
          </div>
        </div>
      </li>
    </ul>
    <div class="main-title">
      {{ board ? "Board / " + board.name : routeName }}
    </div>

    <div class="navbar-nav align-items-center ml-md-auto">
      <div class="media align-items-center">
        <div class="media-body ml-2 d-none d-lg-block">
          <div class="text-right ml-auto">
            <span class="mb-0 text-sm font-weight-bold main-title--sub"
              >Welcome {{ userName }}
            </span>
            <button
              type="button"
              class="btn btn-sm btn-neutral"
              @click="logout()"
            >
              LOG OUT
            </button>
          </div>
        </div>
      </div>
    </div>
    <ul class="navbar-nav align-items-center ml-auto ml-md-0 d-lg-none">
      <base-dropdown
        menu-on-right
        class="nav-item"
        tag="li"
        title-tag="a"
        title-classes="nav-link pr-0"
      >
        <a href="#" class="nav-link pr-0" @click.prevent slot="title-container">
          <div class="media align-items-center">
            <span class="avatar avatar-sm rounded-circle">
              <img
                alt="Profile picture"
                src="/img/theme/profile-placeholder.png"
              />
            </span>
          </div>
        </a>

        <template>
          <div class="dropdown-header noti-title">
            <h6 class="text-overflow m-0">Welcome {{ userName }}</h6>
          </div>

          <div class="dropdown-divider"></div>
          <a href="#!" @click="logout()" class="dropdown-item">
            <i class="ni ni-user-run"></i>
            LOG OUT
          </a>
        </template>
      </base-dropdown>
    </ul>
  </base-nav>
</template>
<script>
import { CollapseTransition } from "vue2-transitions";
import { BaseNav, Modal } from "@/components";
import store from "@/store";

export default {
  components: {
    CollapseTransition,
    BaseNav,
    Modal
  },
  props: {
    type: {
      type: String,
      default: "default", // default|light
      description:
        "Look of the dashboard navbar. Default (blue) or light (gray)"
    },
    name: {
      type: String,
      default: "Dashboard",
      description: "Name to display as page title"
    }
  },
  computed: {
    routeName() {
      const { name } = this.$route;
      return this.capitalizeFirstLetter(name);
    },
    userName() {
      return store.state.user.me.name;
    },
    board() {
      let boards = store.state.monday.boards;
      return boards.find(board => board.id === this.$route.params.id);
    }
  },
  data() {
    return {
      activeNotifications: false,
      showMenu: false,
      searchModalVisible: false,
      searchQuery: ""
    };
  },
  methods: {
    logout() {
      store.dispatch("user/logout").then(() => {
        this.$router.go({
          path: "/login",
          force: true
        });
      });
    },
    capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
    toggleNotificationDropDown() {
      this.activeNotifications = !this.activeNotifications;
    },
    closeDropDown() {
      this.activeNotifications = false;
    },
    toggleSidebar() {
      this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
    },
    hideSidebar() {
      this.$sidebar.displaySidebar(false);
    }
  }
};
</script>
<style lang="scss" scoped>
.btn-link {
  color: #32325d !important;
}
</style>
